import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class AuthTitle {

    constructor(private titleService: Title) {
    }

    canActivate(route: ActivatedRouteSnapshot) {
        if (route.data["title"]) {
            this.titleService.setTitle("Applicant Form | " + route.data["title"]);
        }

        return true;
    }
}